export function createLegacyRouter({
  windowRef = window,
  documentRef = document,
  getTelegramWebApp,
  resetBattleView,
  screenHandlers = {},
  navOrder = ["home", "store", "collection", "gifts", "battle", "achievements"],
  navItemsSelector = ".nav-item",
  screenSelector = ".screen",
}) {
  function callHandler(handler) {
    if (Array.isArray(handler)) {
      handler.forEach((fn) => {
        if (typeof fn === "function") {
          fn();
        }
      });
      return;
    }
    if (typeof handler === "function") {
      handler();
    }
  }

  function handleMissingScreen(screenName) {
    const availableScreens = Array.from(
      documentRef.querySelectorAll(screenSelector),
    )
      .map((element) => element.id.replace('-screen', ''))
      .slice(0, 10) // Ограничиваем количество для короткого сообщения
      .join(", ");
    const message = `Экран "${screenName}" не найден. Доступно: ${availableScreens}...`;
    const telegramApp = getTelegramWebApp?.();
    if (telegramApp?.showAlert) {
      try {
        telegramApp.showAlert(message);
      } catch (e) {
        // Если сообщение всё ещё слишком длинное, используем короткую версию
        console.error('[Router] Screen not found:', screenName, e);
        telegramApp.showAlert(`Экран "${screenName}" не найден`);
      }
    } else if (typeof windowRef.alert === "function") {
      windowRef.alert(message);
    }
  }

  function showScreen(screenName, { skipReset = false } = {}) {
    try {
      const screens = documentRef.querySelectorAll(screenSelector);
      screens.forEach((element) => element.classList.remove("active"));
      const navItems = documentRef.querySelectorAll(navItemsSelector);
      navItems.forEach((element) => element.classList.remove("active"));

      const screenId = `${screenName}-screen`;
      const screenElement = documentRef.getElementById(screenId);
      if (!screenElement) {
        handleMissingScreen(screenName);
        return;
      }

      if (!skipReset && screenName !== "battle") {
        resetBattleView?.({ reset: true });
      }

      screenElement.classList.add("active");
      if (windowRef.getComputedStyle(screenElement).display === "none") {
        screenElement.style.display = "block";
      }

      const navIndex = navOrder.indexOf(screenName);
      if (navIndex >= 0) {
        const navItem = navItems[navIndex];
        if (navItem) {
          navItem.classList.add("active");
        }
      }

      const telegramApp = getTelegramWebApp?.();
      if (telegramApp?.BackButton) {
        if (screenName === "home") {
          telegramApp.BackButton.hide();
        } else {
          telegramApp.BackButton.show();
        }
      }

      const handler = screenHandlers[screenName];
      callHandler(handler);
    } catch (error) {
      console.error("❌ Ошибка в showScreen:", error);
      const telegramApp = getTelegramWebApp?.();
      const message = "Ошибка при переключении экрана: " + error.message;
      if (telegramApp?.showAlert) {
        telegramApp.showAlert(message);
      } else if (typeof windowRef.alert === "function") {
        windowRef.alert(message);
      }
    }
  }

  return {
    showScreen,
  };
}















